"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CoreProps = require("../utilities/CoreProps");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint-disable no-unused-vars */

const LevelItem = _ref => {
  let {
    className,
    renderAs,
    children,
    centered
  } = _ref;
  const classNames = (0, _classnames.default)({
    'has-text-centered': centered
  });
  const RenderAs = renderAs;
  return /*#__PURE__*/_react.default.createElement(RenderAs, {
    className: (0, _classnames.default)('level-item', className, classNames) || undefined
  }, children);
};
LevelItem.propTypes = {
  className: _propTypes.default.string,
  width: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  renderAs: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object]),
  centered: _propTypes.default.bool
};
LevelItem.defaultProps = {
  renderAs: 'div'
};
var _default = exports.default = (0, _CoreProps.withUiProps)(LevelItem);
//# sourceMappingURL=LevelItem.js.map